module.exports = __webpack_public_path__ + "static/media/Veg Wrap.6751d2cd.jpg";